const { __ } = wp.i18n;

// Helpers
import { sortByKey } from '../utils/helpers';

// Components
import Dealer from './Dealer';

const Dealers = ( { center, dealers, mapInstance, mapAPI } ) => {
	if ( ! mapInstance && ! mapAPI ) {
		return null;
	}

	const currentCenter = new mapAPI.LatLng( center.lat, center.lng );

	const dealersList = dealers.map( dealer => {
		const latLng = new mapAPI.LatLng( dealer.lat, dealer.lng );
		let distance = mapAPI.geometry.spherical.computeDistanceBetween( currentCenter, latLng );
		//convert to km

		let distanceRounded = Math.round( distance / 1000 * 10 ) / 10;

		if ( window.location.href.indexOf( '/us/' ) > -1 ) {
			const distanceMiles = distance * 0.000621371192;
			distanceRounded = Math.round( distanceMiles );
		}
		distance = distanceRounded;

		return {
			...dealer,
			distance,
		};
	} );

	const sortedDealers = sortByKey( dealersList, 'distance' );

	// Show 9 closest dealers to center of map.
	const renderDealers = () => {
		return sortedDealers.slice( 0, 9 ).map( dealer => (
			<Dealer key={ dealer.id } data={ dealer } />
		) );
	};

	return (
		<section className="dealers__list">
			<header className="dealers__list-header">
				<h3 className="text-muted">{ __( 'Closest retailers to selected location', 'ankarsrum' ) }</h3>
			</header>
			<div className="grid grid__vert-align-top">
				{ renderDealers() }
			</div>
		</section>
	);
};

export default Dealers;
